export enum ImmoImageTypes {
	THUMBNAIL = "thumbnails",
	THUMBNAIL_WIDE = "thumbnails_wide",
	IMAGE = "images"
}

export const ImageFetch = (objectFetchId: number, type: ImmoImageTypes) => {
	return fetch("/api/images?id=" + objectFetchId + "&type=" + type);
}

export const ServerSideImageFetch = (objectFetchId: number, type: ImmoImageTypes) => {
	return fetch("http://next:3000/api/images?id=" + objectFetchId + "&type=" + type);
}

export const CreateClientImageUrl = (filename: string, type: ImmoImageTypes) => {
	return process.env.IMAGE_PREFIX + `${type}/${filename}`;
}
